module.exports = __webpack_public_path__ + "static/media/pin-secondary-viajes.aec88df5.png";